import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import documentFieldCorrected, {
	type DocumentFieldCorrectedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentFieldCorrected';
import documentFieldCorrectionFailed, {
	type DocumentFieldCorrectionFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentFieldCorrectionFailed';
import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import type CorrectDocumentField from '@Application/Beneficiaries/Documents/Commands/CorrectDocumentField';
import { put } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentFieldCorrectedAction | DocumentFieldCorrectionFailedAction;

export default (command: CorrectDocumentField) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<DocumentDetailPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/documents/${command.documentId}/fields/${encodeURIComponent(command.fieldKey)}/value`,
				command.toJSON(),
			);

			const action = documentFieldCorrected(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentFieldCorrectionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
